<template>
    <div class="wrap-header">
       <!--  <div class="wrap-brand">
            <router-link :to="{ name: 'login' }">
                <img src="/assets/images/arkadia.svg" alt="Arkadia">
            </router-link>
        </div> -->
        <div v-html="handleLogo()"></div>
    </div>
</template>
<script>
export default {
    methods: {
        handleLogo() {
            const urlParams = new URLSearchParams(window.location.search);
            this.tag = urlParams.get("ref");
            if(this.tag =="iklandisini") {
                return `<div class="wrap-logo-iklandisini"><img src="/assets/images/logo-iklandisini.png" alt="iklandisini"></div>`
            } else if (this.tag =="serbada"){
                return `<div class="wrap-logo-serbada"><img src="/assets/images/logo-serbada.png" alt="serbada"></div>`

            } else if (this.tag =="matamata"){
                return `<div class="wrap-logo-matamata"><img src="/assets/images/logo-matamata.png" alt="matamata"></div>`

            } else if (this.tag =="suara"){
                return `<div class="wrap-logo-suara"><img src="/assets/images/logo-suara.png" alt="suara"></div>`    

            } else if (this.tag =="none"){
                return ``
            } else {
                return `<div class="wrap-logo"><img src="/assets/images/yoursay-light.svg" alt="Arkadiame"></div>`
            }

            // var url = (window.location !== window.parent.location)
            //     ? document.referrer
            //     : document.location.href;

                
            // if (url === 'https://www.iklandisini.com/') {
            //     return `<div class="wrap-logo bg-white"><img src="/assets/images/logo/logo-iklandisini.png" alt="Iklan Disini"></div>`
            // } else if (url === 'https://www.bolatimes.com/') {
            //     return `<div class="wrap-logo bolatimes"><img src="/assets/images/logo/logo-bolatimes.png" alt="Bola Times"></div>`
            // } else if (url === 'https://www.dewiku.com/') {
            //     return `<div class="wrap-logo dewiku"><img src="/assets/images/logo/logodewiku.png" alt="Dewiku"></div>`
            // } else if (url === 'https://www.guideku.com/') {
            //     return `<div class="wrap-logo guideku"><img src="/assets/images/logo/logoguideku.png" alt="Guideku"></div>`
            // } else if (url === 'https://www.himedik.com/') {
            //     return `<div class="wrap-logo himedik"><img src="/assets/images/logo/logo-himedik.png" alt="HiMedik"></div>`
            // } else if (url === 'https://www.hitekno.com/') {
            //     return `<div class="wrap-logo hitekno"><img src="/assets/images/logo/logo-hitekno.png" alt="HiTekno"></div>`
            // } else if (url === 'https://www.matamata.com/') {
            //     return `<div class="wrap-logo matamata"><img src="/assets/images/logo/logo-matamata.png" alt="Mata Mata"></div>`
            // } else if (url === 'https://www.mobimoto.com/') {
            //     return `<div class="wrap-logo mobimoto"><img src="/assets/images/logo/logo-mobimoto.png" alt="Mobimoto"></div>`
            // } else if (url === 'https://beta.serbada.com/' || url === 'https://www.serbada.com/') {
            //     return `<div class="wrap-logo serbada"><img src="/assets/images/logo/logo-serbada.png" alt="Serbada"></div>`
            // } else if (url === 'https://clickmov.suara.com/') {
            //     return `<div class="wrap-logo clickmov"><img src="/assets/images/logo/logo-clickmov.svg" alt="Clickmov"></div>`
            // } else {
            //     return `<div class="wrap-logo"><img src="/assets/images/yoursay-light.svg" alt="Arkadia"></div>`
            // }
        }
    }
}
</script>
<style>
    .wrap-header {
        display: block;
    }
    .wrap-brand {
        text-align: center;
        padding: 15px;
        background: #fff;
    }
    .wrap-brand img {
        width: 170px;
        height: auto;
    }
    .wrap-logo {
        text-align: center;
        padding: 10px;
        background: #EC550E;
    }
    .wrap-logo.bolatimes {
        background: #008456;
    }
    .wrap-logo.dewiku {
        background: #DF1180;
    }
    .wrap-logo.guideku {
        background: #99B787;
    }
    .wrap-logo.himedik {
        background: #00c5cf;
    }
    .wrap-logo.hitekno {
        background: #333;
    }
    .wrap-logo.matamata {
        background: #ffeb3c;
        text-align: center;
        padding: 10px;
    }
    .wrap-logo-suara {
      background: #f3f3f3;
      text-align: center;
      padding: 10px;
    }
    .wrap-logo.mobimoto {
        background: #baa66d;
    }
    .wrap-logo.serbada {
        background: #fff;
    }

    .wrap-logo-serbada {
        background: #ED9E22;
        text-align: center;
        padding: 10px;
    }
    .wrap-logo-iklandisini{
        background: #E53C43;
        text-align: center;
        padding: 10px;
    }
    .
    .wrap-logo.clickmov {
        background: #46184a;
    }
    .wrap-logo img {
        width: 170px;
        height: auto;
    }
</style>
